import { render, staticRenderFns } from "./table.vue?vue&type=template&id=8c8b3b12&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=8c8b3b12&prod&lang=scss&scoped=true"
import style1 from "./table.vue?vue&type=style&index=1&id=8c8b3b12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8b3b12",
  null
  
)

export default component.exports